/**
 * @fileoverview ログ util
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
// Config Import
import AppConfig from '../AppConfig';
// Util Import
import * as ConstUtil from './ConstUtil';
import * as DateUtil from './DateUtil';

/**
 * @name log
 * @function
 * @param {Number} level ログレベル
 * @param {String} msg メッセージ
 */
const logselecter = (level, message) => {
  // メッセージに時刻を追加
  const nowTime = DateUtil.UnixTimeToDateString(
    new Date().getTime(),
    'YYYY年MM月DD日 HH時mm分'
  );
  message =
    '[' +
    nowTime +
    '][' +
    ConstUtil.Common.LOG_LEVEL_KEY[level] +
    ']' +
    message;

  // コンソール表示フラグチェック
  if (AppConfig.log.console.enable) {
    // コンソール表示レベルチェック
    if (level >= AppConfig.log.console.level) {
      // コンソール表示関数をコール
      showConsole(message);
    }
  }

  // ログ保存フラグチェック
  if (AppConfig.log.record.enable) {
    // ログ保存レベルチェック
    if (level >= AppConfig.log.record.level) {
      // ログ保存関数をコール
      writeLog(message, nowTime);
    }
  }
};

/**
 * コンソール表示
 * @name showConsole
 * @function
 * @param {String} message メッセージ
 */
const showConsole = message => {
  window.console.info(message);
};

/**
 * ログ保存
 * @name writeLog
 * @function
 * @param {String} message メッセージ
 * @param {String} nowTime 現在時刻
 */
const writeLog = (message, nowTime) => {
  // ローカルストレージから現在保存されているログを取得
  let localStorageLog = JSON.parse(
    localStorage.getItem(ConstUtil.Common.STORAGE_KEY.LOG)
  );

  // 空の場合
  if (_.isEmpty(localStorageLog)) {
    // 初期化
    localStorageLog = [];
  }

  // 配列でない場合
  if (!(localStorageLog instanceof Array)) {
    // 初期化
    localStorageLog = [];
  }

  // ログが1000件以上の場合
  if (
    Object.keys(localStorageLog).length >= ConstUtil.Common.LOG_RECORD_MAX_COUNT
  ) {
    // 一番古いログを削除
    delete localStorageLog[0];
  }

  // ログを追加
  localStorageLog.push(message);

  // localStorageにセット
  localStorage.setItem(
    ConstUtil.Common.STORAGE_KEY.LOG,
    JSON.stringify(localStorageLog)
  );
};

/**
 * Log verbose
 *
 * @param {String} message
 */
export const v = message => {
  logselecter(ConstUtil.Common.LOG_LEVEL.verbose, message);
};

/**
 * Log debug
 *
 * @param {String} message
 */
export const d = message => {
  logselecter(ConstUtil.Common.LOG_LEVEL.debug, message);
};

/**
 * Log info
 *
 * @param {String} message
 */
export const i = message => {
  logselecter(ConstUtil.Common.LOG_LEVEL.info, message);
};

/**
 * Log warning
 *
 * @param {String} message
 */
export const w = message => {
  logselecter(ConstUtil.Common.LOG_LEVEL.warning, message);
};

/**
 * Log error
 *
 * @param {String} message
 */
export const e = message => {
  logselecter(ConstUtil.Common.LOG_LEVEL.error, message);
};



// WEBPACK FOOTER //
// ./src/js/util/LogUtil.jsx